import {
    AlertIcon,
    CalendarIcon,
    LawIcon,
    PencilIcon,
    RowsIcon,
    StackIcon,
    StopIcon
} from "@primer/octicons-react";
import { Box, Flash, IconButton, Octicon } from '@primer/react';
import { useEffect, useState } from "react";
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import UserAvatar from "../../../components/user-avatar";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { IHocSinhViewModel } from "../../../models/response/category/IHocSinhViewModel";
import { thuPhiTabAction } from "../../../state/actions/thu-phi-tab/thuPhiTabAction";
import { IThuPhiTabReducer } from "../../../state/page-state-model/IThuPhiTabReducer";
import { RootState } from '../../../state/reducers';

interface IHocSinhShortInfoProps {
    hocSinh?: IHocSinhViewModel,
    selectedTab: IThuPhiTabReducer
}
const HocSinhShortInfo = (props: IHocSinhShortInfoProps) => {
    const { hocSinh } = props;
    const { nam_hoc } = useSelector((x: RootState) => x.common);
    const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
    const dispatch = useDispatch();

    const handleReloadTienThuaHocSinh = async () => {
        if (hocSinh) {
            const datasend: sf_mucphaithu_select_byhocsinh_rq = { ts_hocsinh_id: hocSinh.id, nam_hoc: nam_hoc }
            const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
            if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
                set_tong_tien_thua(res.data.tong_tien_thua)
            }
        }
    }
    useEffect(() => {
        if (hocSinh && nam_hoc) {
            handleReloadTienThuaHocSinh();
        }
    }, [hocSinh, nam_hoc])
    return (
        <Box sx={{ width: "100%" }}>
            {!hocSinh &&
                <Box sx={{ pl: 1 }}>
                    <Flash sx={{ mt: 2 }} variant='warning'>
                        <Box>
                            <Octicon icon={AlertIcon} />
                            Chọn học sinh từ danh sách để bắt đầu thu phí
                        </Box>
                    </Flash>
                </Box>
            }
            {hocSinh &&
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', pl: 2 }}>
                        <Box sx={{ width: 30, pt: 2 }}>
                            <UserAvatar fullName={hocSinh?.ho_ten} size="large" />
                        </Box>
                        <Box
                            style={{
                                display: "grid",
                                marginLeft: "10px",
                                justifyContent: "flex-start",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span style={{ fontWeight: "600", fontSize: 17 }}>{hocSinh?.ho_ten}</span>
                            </div>
                            <span style={{ fontWeight: "400", fontSize: 12 }}>{hocSinh?.ma_hs}</span>

                        </Box>
                        <Box sx={{ display: "flex", gap: "24px", ml: "30px", flexWrap: "wrap" }}>
                            {[
                                { label: "Tên trường", value: hocSinh?.ten_truong },
                                { label: "Tên khối", value: hocSinh?.ten_khoi },
                                { label: "Tên hệ", value: hocSinh?.ten_he },
                                { label: "Tên lớp", value: hocSinh?.ten_lop },
                                { label: "Số tiền khả dụng", value: <>{tong_tien_thua.toLocaleString()} <sup>đ</sup></>, align: "right" as const }
                            ].map((item) => (
                                <Box key={item.label} sx={{ display: "flex", flexDirection: "column" }}>
                                    <Box as="span" sx={{ fontSize: 12, color: "fg.muted", mb: 1, whiteSpace: "nowrap" }}>{item.label}</Box>
                                    <Box as="span" sx={{ fontWeight: 600, textAlign: item.align || "left" }}>{item.value || "-"}</Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                </Box>
            }
        </Box >



    );
};

export default HocSinhShortInfo;